export const noop = (): void => {
  /* no operation */
};
